import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import { Button } from '@/design-system'
import { FormPage, FormSub, FormTitle, FormWrap } from './__styled'

const SuccessGlyph = () => (
  <Box
    sx={{
      width: 48,
      height: 48,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 22,
      color: '#fff',
      background: 'var(--ds-gradient-spectrum, var(--ds-ink))',
      marginBottom: 22,
    }}
    aria-hidden
  >
    ✓
  </Box>
)

export default function ForgotForm3() {
  const navigate = useNavigate()
  const onSignIn = () => navigate('/login')

  return (
    <FormPage>
      <FormWrap>
        <SuccessGlyph />
        <FormTitle>Password reset</FormTitle>
        <FormSub>Your password has been successfully reset. Sign in with your new password.</FormSub>

        <Button variant='spectrum' size='lg' fullWidth onClick={onSignIn}>
          Sign in →
        </Button>
      </FormWrap>
    </FormPage>
  )
}
